import React from "react";

import { mdiImageFilterHdr } from "@mdi/js";
import Icon from "@mdi/react";
import { useTranslation } from "react-i18next";

import {
  PictureRatio,
  PictureRatioContainer,
  PictureRatioLabel,
  PictureRatioWrapper,
} from "./CarouselPictureRatio";
import COLORS from "../../../constants/colors";

import type { JSX } from "react";

import type { HorizontalImageFormat } from "../../../constants/ratio";

interface CarouselSingleRowProps {
  onClick: (row: "single") => void;
  isSelected: boolean;
  ratio?: HorizontalImageFormat;
}

function CarouselSingleRow({
  onClick,
  isSelected,
  ratio,
}: CarouselSingleRowProps): JSX.Element {
  const { t } = useTranslation("editor-platform");

  return (
    <PictureRatioWrapper
      className="gap-[0.3125rem]"
      onClick={(): void => onClick("single")}
    >
      <PictureRatioContainer isSelected={isSelected}>
        <PictureRatio
          className="h-[100px]"
          isSelected={isSelected}
          ratio={ratio}
        >
          <Icon
            color={isSelected ? COLORS.primary.DEFAULT : COLORS.grey.DEFAULT}
            path={mdiImageFilterHdr}
            size="38px"
          />
        </PictureRatio>
      </PictureRatioContainer>
      <PictureRatioLabel isSelected={isSelected}>
        {t("carouselFormat.single")}
      </PictureRatioLabel>
    </PictureRatioWrapper>
  );
}

export default CarouselSingleRow;
